import { ConsultantContractGeneratorType } from "../../consultant-contract-generator-type";
import {
  IConsultantContractStrategy,
  CanSendToOneflowContext,
  GetOneflowTemplateIdContext,
  CanGenerateByOneflowContext,
  CanPreviewContext,
  CanDownloadContext
} from "../consultant-contract-strategy";
import { ContractType } from "@bonliva-crm/shared";

export class IntermittentNationalFullContractStrategy
  implements IConsultantContractStrategy
{
  public readonly name = "IntermittentNationalFullContractStrategy";

  canPublishToOneflowDirectly(ctx: CanSendToOneflowContext): boolean {
    return true;
  }

  canPublishToOneflowViaTicket(ctx: CanSendToOneflowContext): boolean {
    return true;
  }

  getOneflowGeneratorType(ctx: CanGenerateByOneflowContext) {
    return ctx.tenant === "wcc"
      ? ConsultantContractGeneratorType.IntermittentNationalTemplateDataGenerator
      : null;
  }

  getOneflowTemplateId(ctx: GetOneflowTemplateIdContext) {
    if (ctx.env === "dev" || ctx.env === "staging") {
      return ctx.tenant === "wcc"
        ? { workspaceId: "419741", templateId: "11860425" }
        : { workspaceId: "419741", templateId: "6299948" };
    }

    if (ctx.env === "production") {
      return ctx.tenant === "wcc"
        ? { workspaceId: "457689", templateId: "12120631" }
        : { workspaceId: "406174", templateId: "6245988" };
    }

    throw new Error("Unhandled env");
  }

  canDuplicate(): boolean {
    return true;
  }

  canEdit(): boolean {
    return true;
  }

  canPreview(ctx: CanPreviewContext): boolean {
    return ctx.tenant !== "wcc";
  }

  canDownload(ctx: CanDownloadContext): boolean {
    return !!ctx.fileId;
  }

  defaultSalaryChoice(): ContractType {
    return ContractType.NationalProcurement;
  }
}
